import React from 'react';
import { UpdatePhotoEvents } from './events/event-declarations';
import { builderDispatch } from '../../_utils/ui';

const ListQuantityFieldHandlers = WrappedComponent => props => {
  const MAX_QUANTITY = 999;

  const add = quantity => {
    builderDispatch.dispatch({
      type: UpdatePhotoEvents.ADD_TO_SIZE,
      root_image_id: props.rootIds || props.rootId,
      targetSizeKey: props.sizeKey,
      quantity,
    });
  };

  const update = quantity => {
    if (props.onChange) {
      add(quantity);
      return props.onChange(quantity, props.sizeKey);
    }

    return builderDispatch.dispatch({
      type: UpdatePhotoEvents.UPDATE,
      photo: props.photos.map(photo => ({
        ...photo,
        quantity,
      })),
      hard: true,
    });
  };

  const remove = () => {
    const photoIds = props.photos.map(photo => photo.image_id);

    builderDispatch.dispatch({
      type: UpdatePhotoEvents.REMOVE,
      sizeKey: props.sizeKey,
      imageId: photoIds,
    });
  };

  const quantity = () => {
    if (props.photo && props.photo.quantity) {
      return props.photo.quantity;
    }

    const sizeQuantity = props.quantity;

    function reducePhotoQuantity(memo, photo) {
      return memo + (photo.quantity || sizeQuantity || 0);
    }

    return (props.photos || []).reduce(reducePhotoQuantity, 0);
  };

  const handleQuantityChange = e => {
    const value = parseInt(e.target.value || 0, 10);

    if (Number.isNaN(value)) return;

    if (value < 0) {
      e.target.value = 0;
      return;
    }

    if (value > MAX_QUANTITY) {
      e.target.value = MAX_QUANTITY;
      return;
    }

    if (value && quantity() === 0) {
      add(value);
      return;
    }

    if (value) {
      update(value, 'quantity');
      return;
    }

    remove();
  };

  const handleFormSubmit = e => {
    e.preventDefault();
  };

  const newProps = {
    ...props,
    handleFormSubmit,
    handleQuantityChange,
    quantity,
  };

  return <WrappedComponent {...newProps} />;
};

export default ListQuantityFieldHandlers;
